import { TreeSelect } from 'antd';
import React, { useEffect, useMemo, useRef } from 'react';
import { AnalysisStructure } from './types';
import { getFlatSections } from './utils';
import { useFetchAnalysisStructureQuery } from './service';

function getTreeData(analysisStructure: AnalysisStructure) {
    return [
        {
            title: 'All sections',
            value: 'All sections',
            key: 'All sections',
            selectable: true,
            children: Object.keys(analysisStructure).map((category) => ({
                title: category,
                value: category,
                key: category,
                selectable: true,
                children: analysisStructure[category as keyof AnalysisStructure].map((section) => ({
                    title: section.title,
                    value: section.title,
                    key: section.key,
                    selectable: false,
                })),
            })),
        },
    ];
}

type Props = {
    selectedSectionTitles: string[];
    onSelectedSectionTitlesChange: (newSelectedSectionTitles: string[]) => void;
};

export default function SectionsSelector({ selectedSectionTitles, onSelectedSectionTitlesChange }: Props) {
    const { data: analysisStructure } = useFetchAnalysisStructureQuery({ fields: ['key', 'title', 'relevance'] });

    const isFirstTimeSettingAnalysisStructure = useRef<boolean>(true);

    const treeData = useMemo(() => (analysisStructure ? getTreeData(analysisStructure) : []), [analysisStructure]);

    useEffect(() => {
        if (analysisStructure && isFirstTimeSettingAnalysisStructure.current) {
            isFirstTimeSettingAnalysisStructure.current = false;

            const sections = getFlatSections(analysisStructure);
            const titles = sections.map((section) => section.title);

            onSelectedSectionTitlesChange(titles);
        }
    }, [analysisStructure, onSelectedSectionTitlesChange]);

    return (
        <TreeSelect
            className="tree-select"
            treeData={treeData}
            value={selectedSectionTitles}
            searchPlaceholder="Edit Checkup Factors"
            maxTagCount={1}
            allowClear
            treeCheckable
            multiple
            treeDefaultExpandAll
            onChange={onSelectedSectionTitlesChange}
            dropdownStyle={{
                maxHeight: 400,
                overflow: 'auto',
            }}
        />
    );
}
